import type { AdminHostPoolWithType } from "@/admin/host_pools/hostPoolsQuery.ts";
import { defaultHostsMutation } from "@/admin/host_pools/hostPoolsQuery.ts";
import { WModal, WModalContent } from "@/components/modal/WModal.tsx";
import { useStandardMutation } from "@/modules/api/useStandardMutation.ts";
import type { ReactNode } from "react";

export function ToggleHvAutoAssignedModal({ button, item }: { button: ReactNode; item: AdminHostPoolWithType }) {
    const updateMutation = useStandardMutation(defaultHostsMutation);

    async function onToggle() {
        await updateMutation.mutateAsync({
            location: item.location,
            uuid: item.uuid,
        });
    }

    return (
        <WModal button={button}>
            <WModalContent
                title="Set Default Pool for Hosts"
                label="Set Default"
                modalAction={async () => await onToggle()}
            >
                <p>New hosts that are added to the cluster will be automatically assigned to this pool.</p>
            </WModalContent>
        </WModal>
    );
}
